/* Goldstein: extend Broadcast's native AjaxAdd, never replace cart providers. */
(function () {
  'use strict';
  var theme = window.theme;
  if (!theme || !theme.AjaxAdd || theme.AjaxAdd.prototype.goldsteinConfirmation) return;
  var proto = theme.AjaxAdd.prototype;
  proto.goldsteinConfirmation = true;
  var originalAdd = proto.addItem;
  var originalShow = proto.showCartNotificationPopup;
  var originalClear = proto.clearPopover;
  // One add at a time, including sticky and quickview forms sharing the popup.
  var active = null;
  var owner = null;
  var countRevision = 0;

  function release(instance) {
    if (active !== instance) return;
    active = null;
    instance.$button.each(function () {
      this.disabled = false;
      this.removeAttribute('aria-busy');
    });
  }
  function returnFocus(instance) {
    var button = instance.goldsteinTrigger;
    if (button && button.isConnected) button.focus({ preventScroll: true });
  }
  proto.addItem = function (data) {
    if (active) return;
    active = this;
    this.goldsteinQuantity = Number(data.quantity || 1);
    var focusedForm = document.activeElement && document.activeElement.closest('form');
    this.goldsteinTrigger = focusedForm && focusedForm.querySelector('[data-add-to-cart]') || document.activeElement;
    this.$button.each(function () {
      this.disabled = true;
      this.setAttribute('aria-busy', 'true');
    });
    this.$errors.empty().removeClass('is-visible');
    this.$popover.removeClass('is-visible');
    clearTimeout(this.popoverTimer);
    try { originalAdd.call(this, data); }
    catch (error) { this.addToCartFail({}); }
  };
  proto.addToCartOkay = function (product) {
    // The response quantity can be the merged line total. Confirm the actual
    // request quantity, not the now-editable input or accumulated line total.
    release(this);
    originalShow.call(this, product);
    clearTimeout(this.popoverTimer);
    owner = this;
    var revision = ++countRevision;
    var popup = this.popoverContainer;
    popup.inert = false;
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-label', 'Added to cart');
    popup.setAttribute('aria-modal', 'false');
    popup.setAttribute('aria-hidden', 'false');
    var title = popup.querySelector('.product__title');
    if (title) title.textContent = this.goldsteinQuantity + ' × ' + product.product_title;
    var price = popup.querySelector('.product__price');
    if (price) price.textContent = slate.Currency.formatMoney(
      product.final_price != null ? product.final_price : product.price, theme.moneyFormat
    ).replace(/<[^>]*>/g, '');
    var heading = popup.querySelector('h6');
    if (heading) heading.setAttribute('role', 'status');
    var content = popup.querySelector('.product__add__success__content');
    var plan = product.selling_plan_allocation && product.selling_plan_allocation.selling_plan;
    if (content) {
      var purchase = document.createElement('p');
      purchase.textContent = plan ? 'Standing order · ' + plan.name : 'One-time purchase';
      content.insertBefore(purchase, content.querySelector('.buttons-wrap'));
    }
    var self = this;
    popup.onclick = function (event) {
      if (event.target.closest('[data-shop-continue-shopping]')) {
        event.preventDefault();
        self.clearPopover();
      }
    };
    popup.onkeydown = function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        self.clearPopover();
      }
    };
    var close = popup.querySelector('.close');
    if (close) close.focus({ preventScroll: true });
    // Read authoritative count after success; never speculate from an old badge.
    // Provider metadata and delivery dates are read only, never rewritten here.
    fetch((window.Shopify && window.Shopify.routes.root || '/') + 'cart.js', {
      credentials: 'same-origin', cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart count unavailable');
      return response.json();
    }).then(function (cart) {
      if (revision !== countRevision) return;
      document.querySelectorAll('#CartButton .cart-count-js').forEach(function (badge) {
        badge.textContent = String(cart.item_count);
        badge.style.display = '';
      });
    }).catch(function () {
      if (heading && popup.classList.contains('is-visible')) {
        heading.textContent = 'Added to cart. View Cart to check your basket total.';
      }
    });
  };
  proto.addToCartFail = function (response) {
    release(this);
    this.$popover.empty().removeClass('is-visible');
    clearTimeout(this.popoverTimer);
    var error = document.createElement('p');
    error.setAttribute('role', 'alert');
    error.textContent = response.responseJSON && response.responseJSON.description
      ? String(response.responseJSON.description) + ' Check your selection and try again.'
      : 'We could not confirm the addition. View your cart before trying again to avoid adding it twice.';
    var link = document.createElement('a');
    link.href = (window.Shopify && window.Shopify.routes.root || '/') + 'cart';
    link.textContent = 'View Cart';
    this.$errors.empty().append(error, link).addClass('is-visible');
  };
  proto.clearPopover = function () {
    // Quickviews share a global popover and each binds native close handlers.
    if (owner && owner !== this) return;
    clearTimeout(this.popoverTimer);
    originalClear.call(this);
    this.popoverContainer.setAttribute('aria-hidden', 'true');
    this.popoverContainer.inert = true;
    returnFocus(this);
  };
})();
